import { h } from 'preact'

import { IconComponentProps } from './index'

const TopicIcon = ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={customClass}>
    <path d='M21.6 0H2.4C1.08 0 0.012 1.08 0.012 2.4L0 24L4.8 19.2H21.6C22.92 19.2 24 18.12 24 16.8V2.4C24 1.08 22.92 0 21.6 0ZM19.2 14.6667H4.8V12.6667H19.2V14.6667ZM19.2 10.6667H4.8V8.66667H19.2V10.6667ZM19.2 6.66667H4.8V4.66667H19.2V6.66667Z' fill={color} />
  </svg>
)

export default TopicIcon
